'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sidebarMapping = undefined;

var _sidebarMapping;

var _appNames = require('../constants/appNames');

var _appNames2 = _interopRequireDefault(_appNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sidebarMapping = exports.sidebarMapping = (_sidebarMapping = {}, _defineProperty(_sidebarMapping, _appNames2.default.academySignup, {
  customLogo: 'academyLogoText',
  illustration: 'design-principle-integrated',
  sidebarMessage: 'core.accountDetails.sidebarDescription.AcademySignup',
  logoStyles: {
    width: '250px'
  }
}), _defineProperty(_sidebarMapping, _appNames2.default.crmSignup, {
  sidebarMessage: 'core.accountDetails.sidebarDescription.CrmSignup'
}), _defineProperty(_sidebarMapping, 'wordpress', {
  customLogo: 'hubspotWordpressLogo',
  illustration: 'integrations',
  sidebarMessage: 'core.accountDetails.sidebarDescription.wordpress',
  logoStyles: {
    width: 250
  },
  plainSidebar: true
}), _sidebarMapping);

exports.default = sidebarMapping;